<template>
  <div class="container mb-3">
    <v-btn
      flat
      icon
      small
      color="#fff"
      class="delete"
      @click="deleteMsg()"
    >
      <v-icon style="font-size: 15px; width: 0">
        mdi-close
      </v-icon>
    </v-btn>
    <div class="mt-4">
      Solicitação negada. Converse com a gerência para entender o motivo.
    </div>
    <div class="mt-2">
      <b>{{ product.descricaoCurta }}</b> retirado do carrinho.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters([
      'getCatalogue',
    ]),
  },
  methods: {
    deleteMsg() {
      const pos = this.getCatalogue.findIndex((p) => p.id === this.product.id);
      if (pos >= 0) {
        this.getCatalogue.splice(pos, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.container {
  position: relative;
  background: #FF5146;
  color: white;
  border-radius: 4px;
  text-align: left;
}

.delete {
  margin-left: 0.5rem !important;
  margin-right: 0 !important;
  position: absolute;
  right: 5px;
  top: 0;
}

</style>
